<template>
  <div class="main-content-container container-fluid px-4">
    <d-row class="page-header no-gutters pb-4">
      <d-col cols="12" lg="6">
        <span class="text-uppercase page-subtitle">{{ subtitle }}</span>
        <h3 class="page-title">{{ title }}</h3>
      </d-col>
      <d-col cols="12" lg="6">
        <slot name="header"></slot>
      </d-col>
    </d-row>
    <d-row>
      <d-col cols="12" :md="!!this.$slots.sidebar ? 8 : 12">
        <slot></slot>
      </d-col>
      <d-col v-if="this.$slots.sidebar" cols="0" md="4">
        <slot name="sidebar"></slot>
      </d-col>
    </d-row>
  </div>
</template>

<script>
export default {
  name: "odd-page",
  data() {
    return {};
  },
  props: {
    title: {
      type: String,
      required: true
    },
    subtitle: {
      type: String,
      default: ""
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
